// Platform SMTP email transport client — /api/v1/platform/email/config…
//
// The single `scope = 'PLATFORM'` row that carries Orio360's own outbound mail
// (OTP, invites, lifecycle). SUPER_ADMIN writes, ADMIN reads — enforced by the
// controller; the UI only decides whether to render the form read-only.

import { apiClient } from '@/lib/api-client';
import type {
  EmailTransportConfigMasked,
  EmailVerificationOutcome,
  TestEmailResult,
  UpsertEmailTransportInput,
  UpsertEmailTransportResult,
  VerifyEmailTransportResult,
} from '@bbpos/types';
import type { EmailTransportClient } from './email-transport.service';

const BASE = '/platform/email/config';

export const platformEmailService: EmailTransportClient = {
  getConfig() {
    return apiClient<EmailTransportConfigMasked>(BASE);
  },

  upsertConfig(input: UpsertEmailTransportInput) {
    return apiClient<UpsertEmailTransportResult>(BASE, { method: 'PUT', body: input });
  },

  verify(code: string) {
    return apiClient<VerifyEmailTransportResult>(`${BASE}/verify`, {
      method: 'POST',
      body: { code },
    });
  },

  resendVerification() {
    return apiClient<EmailVerificationOutcome>(`${BASE}/verify/resend`, { method: 'POST' });
  },

  sendTest(to?: string) {
    return apiClient<TestEmailResult>(`${BASE}/test`, {
      method: 'POST',
      body: to ? { to } : {},
    });
  },

  disableConfig() {
    return apiClient<{ disabled: boolean }>(BASE, { method: 'DELETE' });
  },
};
